import { MATERIALS } from '../types';

export default function MaterialFilter({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <select className="select" style={{ width: 'auto' }} value={value} onChange={(e) => onChange(e.target.value)}>
      {MATERIALS.map((m) => (
        <option key={m.key} value={m.key}>
          {m.name}
        </option>
      ))}
    </select>
  );
}
